import classnames from 'classnames';
import React, { FC } from 'react';
import { ChevronLeft, ChevronRight } from '../../../../components/common/WixIcons';
import styles from './HomeSliderArrows.scss';
import { IOuter } from './HomeSliderArrows.types';

export const HomeSliderArrows: FC<IOuter> = ({ sliderLeftClick, sliderRightClick, showRightArrow, showLeftArrow }) => (
  <div className={styles.arrows}>
    <ChevronLeft
      className={classnames(styles.leftArrow, {
        [styles.hidden]: !showLeftArrow,
      })}
      data-hook="home-slider-nav-left"
      onClick={sliderLeftClick}
    />

    <ChevronRight
      className={classnames(styles.rightArrow, {
        [styles.hidden]: !showRightArrow,
      })}
      data-hook="home-slider-nav-right"
      onClick={sliderRightClick}
    />
  </div>
);
